import type { RouteRecordName } from '#vue-router'

export const useUseSubPages = (subRoutes: Record<RouteRecordName, { image?: string, suptitle?: string, title?: string, subtitle?: string }>) => {
  const { getTranslatedLink } = useGetTranslatedLink()

  const route = useRoute()

  const navLinks = keysFromObject<typeof subRoutes>(subRoutes).map(name => ({
    to: { name },
    text: getTranslatedLink(name.toString()),
  }))

  const currentSubRoute = computed(() => {
    if (!route.name) {
      return null
    }
    return subRoutes[route.name]
  })

  return { navLinks, currentSubRoute }
}
